import { useContext } from "react";
import ModalsContext from "./context";

const useModalContext = () => {
    return useContext(ModalsContext);
};

export default useModalContext;
